const MaritalStatus = [
	'Célibataire',
	'Union libre',
	'Marié(e)',
	'Veuf/Veuve',
	'Divorcé(e)',
	'Pacsé(e)',
	'Séparé(e)'
]

export default MaritalStatus



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/MaritalStatus.js